import { loadSdk, logEvent, getGameCode } from '@/page/embed-page/download-in-app/server';

export function launchApp(params) {
  const blockedGameCodes = [
    'ty', // 天涯明月刀手游
    'mir', // 热血传奇
    'bwzy', // 三国群英传
    'mhzx', // 梦幻诛仙
    'jxqy', // 剑仙情缘
    'gwgo', // 一起来捉妖
    'xiawa', // 龙族幻想
    'lzhx', // 龙族幻想
  ];
  // 游戏合规需要，暂时屏蔽下载
  const gameCode = getGameCode();
  if (blockedGameCodes.includes(gameCode)) {
    alert('系统升级，请直接前往闪现一下APP内进行查看和处理');
  } else {
    loadSdk().then(() => {
      SX_WEB.app.launch({
        actId: 'sx_game_embed_page_20200716',
        actName: '游戏内嵌页',
        autoInstall: true,
        downloadUrlParams: {
          shanxianinchannel: gameCode,
        },
        ...params,
      });
    });
  }
}

export function launchByScheme() {
  const gameCode = getGameCode();
  logEvent({ eventType: 3, extendId: 1, operId: '1901000010301' });
  launchApp({
    scheme: `tgc://native?moduleName=renowndetail&toWeekly=1&srcType=6&srcId=${gameCode}`,
  });
}
